import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M47.33 534.952c0 269.653 217.966 487.619 487.617 487.619 269.653 0 487.619-217.966 487.619-487.619s-217.966-487.619-487.619-487.619c-269.651 0-487.617 217.966-487.617 487.619zM744.624 325.276c19.017 19.017 19.017 49.737 0 68.754l-140.922 140.922 140.922 140.922c19.017 19.017 19.017 49.737 0 68.754s-49.737 19.017-68.754 0l-140.922-140.922-140.92 140.922c-19.017 19.017-49.737 19.017-68.754 0s-19.017-49.737 0-68.754l140.922-140.922-140.922-140.922c-19.017-19.017-19.017-49.737 0-68.754s49.737-19.017 68.754 0l140.92 140.922 140.922-140.922c18.53-18.53 49.737-18.53 68.754 0z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
